import { Status as o } from "@prometheus/types";
import D from "immer";
import { api as d, parseNotifications as ce, parseInvitations as ie, getReducerWithProduce as _e, getSortDirection as ue } from "@prometheus/utils";
import { TypesOfContainer as de } from "@prometheus/enums";
var i = /* @__PURE__ */ ((e) => (e.GET_NOTIFICATIONS = "GET_NOTIFICATIONS", e.GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS", e.GET_NOTIFICATIONS_ERROR = "GET_NOTIFICATIONS_ERROR", e.MARK_NOTIFICATIONS_READ = "MARK_NOTIFICATIONS_READ", e.MARK_NOTIFICATIONS_READ_SUCCESS = "MARK_NOTIFICATIONS_READ_SUCCESS", e.MARK_NOTIFICATIONS_READ_ERROR = "MARK_NOTIFICATIONS_READ_ERROR", e.GET_NOTIFICATIONS_UNREAD = "GET_NOTIFICATIONS_UNREAD", e.GET_NOTIFICATIONS_UNREAD_SUCCESS = "GET_NOTIFICATIONS_UNREAD_SUCCESS", e.GET_NOTIFICATIONS_UNREAD_ERROR = "GET_NOTIFICATIONS_UNREAD_ERROR", e))(i || {});
const Rn = () => ({
  type: i.GET_NOTIFICATIONS_UNREAD
}), Re = (e) => ({
  type: i.GET_NOTIFICATIONS_UNREAD_SUCCESS,
  payload: e
}), le = () => ({
  type: i.GET_NOTIFICATIONS_UNREAD_ERROR
}), ln = (e) => ({
  type: i.GET_NOTIFICATIONS,
  payload: e
}), Ne = (e) => ({
  type: i.GET_NOTIFICATIONS_SUCCESS,
  payload: e
}), Ae = () => ({
  type: i.GET_NOTIFICATIONS_ERROR
}), Nn = (e) => ({
  type: i.MARK_NOTIFICATIONS_READ,
  payload: e
}), Ce = (e) => ({
  type: i.MARK_NOTIFICATIONS_READ_SUCCESS,
  payload: e
}), ye = () => ({
  type: i.MARK_NOTIFICATIONS_READ_ERROR
}), Oe = {
  notifications: [],
  unreadNotificationsIds: [],
  count: 0,
  totalElements: 0,
  status: o.INITIAL,
  unreadStatus: o.INITIAL
}, An = (e = Oe, t) => D(e, (n) => {
  switch (t.type) {
    case i.GET_NOTIFICATIONS_UNREAD:
      n.unreadStatus = n.unreadStatus === o.INITIAL ? o.IN_PROGRESS : o.IN_PROGRESS_RELOAD;
      break;
    case i.GET_NOTIFICATIONS_UNREAD_SUCCESS:
      n.unreadNotificationsIds = t.payload.map((E) => E.id), n.count = t.payload.length, n.unreadStatus = o.SUCCESS;
      break;
    case i.GET_NOTIFICATIONS_UNREAD_ERROR:
      n.unreadStatus = o.ERROR;
      break;
    case i.GET_NOTIFICATIONS:
      n.status = n.status === o.INITIAL ? o.IN_PROGRESS : o.IN_PROGRESS_RELOAD;
      break;
    case i.GET_NOTIFICATIONS_SUCCESS:
      n.notifications = t.payload.data, n.totalElements = t.payload.totalElements, n.status = o.SUCCESS;
      break;
    case i.GET_NOTIFICATIONS_ERROR:
      n.status = o.ERROR;
      break;
    case i.MARK_NOTIFICATIONS_READ:
      n.status = o.IN_PROGRESS_RELOAD;
      break;
    case i.MARK_NOTIFICATIONS_READ_SUCCESS:
      const a = t.payload;
      n.notifications = n.notifications.map(
        (E) => a.includes(E.id) ? { ...E, read: !0 } : E
      ), n.status = o.SUCCESS;
      break;
    case i.MARK_NOTIFICATIONS_READ_ERROR:
      n.status = o.ERROR;
      break;
  }
}), pe = (e) => d.get("/affinity?id=" + e), Ue = () => d.get("/invites/details").then(async (e) => {
  const t = [];
  e.forEach((a) => {
    a.analysis && t.push(a.analysis.id);
  });
  const n = t != null && t.length ? await pe(t.join(",")).catch(() => []) : {};
  return e.map((a) => ({
    ...a,
    affinity: a.analysis ? n[a.analysis.id] : null
  }));
}), ge = () => d.get("/invites/count"), fe = (e) => d.post(e), Ge = (e, t) => d.post(t, { note: e || "" }), De = () => d.get("/notifications"), Me = ({
  size: e,
  page: t,
  read: n
}) => d.get(
  `/notifications/list?page=${t || 0}&size=${e || 15}${n === !1 ? "&read=false" : ""}`
), ve = (e) => d.post("/notifications/read", e), me = (e, t) => d.post("/users/login", { login: e, password: t }), Le = () => d.get("/users/active"), Pe = () => d.get("/settings"), be = () => d.post("/users/logout"), he = (e, t) => d.get(
  e === de.STUDY ? `/studies/${t}/summary` : "/workspace/summary"
);
var m = function(t) {
  return "@@redux-saga/" + t;
}, Ve = /* @__PURE__ */ m("CANCEL_PROMISE"), ae = /* @__PURE__ */ m("IO"), Fe = /* @__PURE__ */ m("MULTICAST"), J = /* @__PURE__ */ m("SELF_CANCELLATION"), ke = /* @__PURE__ */ m("TASK"), we = function(t) {
  return t == null;
}, C = function(t) {
  return t != null;
}, p = function(t) {
  return typeof t == "function";
}, x = function(t) {
  return typeof t == "string";
}, L = Array.isArray, Qe = function(t) {
  return t && !L(t) && typeof t == "object";
}, W = function(t) {
  return t && t[ke];
}, z = function e(t) {
  return t && (x(t) || Be(t) || p(t) || L(t) && t.every(e));
}, b = function(t) {
  return t && p(t.take) && p(t.close);
}, $e = function(t) {
  return p(t) && t.hasOwnProperty("toString");
}, Be = function(t) {
  return !!t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype;
}, xe = function(t) {
  return b(t) && t[Fe];
}, qe = function(t) {
  return t && t[ae];
}, k = 2147483647;
function Ke(e, t) {
  if (t === void 0 && (t = !0), process.env.NODE_ENV !== "production" && e > k)
    throw new Error("delay only supports a maximum value of " + k + "ms");
  var n, a = new Promise(function(E) {
    n = setTimeout(E, Math.min(k, e), t);
  });
  return a[Ve] = function() {
    clearTimeout(n);
  }, a;
}
process.env.NODE_ENV !== "production" && typeof Proxy < "u";
var Ye = function(t) {
  return t;
};
function R(e, t, n) {
  if (!t(e))
    throw new Error(n);
}
var je = function(t) {
  throw t;
}, He = function(t) {
  return {
    value: t,
    done: !0
  };
};
function Je(e, t, n) {
  t === void 0 && (t = je), n === void 0 && (n = "iterator");
  var a = {
    meta: {
      name: n
    },
    next: e,
    throw: t,
    return: He,
    isSagaIterator: !0
  };
  return typeof Symbol < "u" && (a[Symbol.iterator] = function() {
    return a;
  }), a;
}
var w = "TAKE", We = "PUT", ze = "ALL", Xe = "CALL", Ze = "FORK", et = "CANCEL", tt = "SELECT", X = `
(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)`, g = function(t, n) {
  var a;
  return a = {}, a[ae] = !0, a.combinator = !1, a.type = t, a.payload = n, a;
};
function Ee(e, t) {
  if (e === void 0 && (e = "*"), process.env.NODE_ENV !== "production" && arguments.length && R(arguments[0], C, "take(patternOrChannel): patternOrChannel is undefined"), z(e))
    return C(t) && console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types"), g(w, {
      pattern: e
    });
  if (xe(e) && C(t) && z(t))
    return g(w, {
      channel: e,
      pattern: t
    });
  if (b(e))
    return C(t) && console.warn("take(channel) takes one argument but two were provided. Second argument is ignored."), g(w, {
      channel: e
    });
  if (process.env.NODE_ENV !== "production")
    throw new Error("take(patternOrChannel): argument " + e + " is not valid channel or a valid pattern");
}
function S(e, t) {
  return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? (R(e, C, "put(channel, action): argument channel is undefined"), R(e, b, "put(channel, action): argument " + e + " is not a valid channel"), R(t, C, "put(channel, action): argument action is undefined")) : R(e, C, "put(action): argument action is undefined")), we(t) && (t = e, e = void 0), g(We, {
    channel: e,
    action: t
  });
}
function h(e) {
  var t = g(ze, e);
  return t.combinator = !0, t;
}
var oe = function(t, n) {
  if (R(n, C, t + ": argument fn is undefined or null"), !p(n)) {
    var a = null, E;
    if (L(n))
      a = n[0], E = n[1], R(E, C, t + ": argument of type [context, fn] has undefined or null `fn`");
    else if (Qe(n))
      a = n.context, E = n.fn, R(E, C, t + ": argument of type {context, fn} has undefined or null `fn`");
    else {
      R(n, p, t + ": argument fn is not function");
      return;
    }
    if (a && x(E)) {
      R(a[E], p, t + ': context arguments has no such method - "' + E + '"');
      return;
    }
    R(E, p, t + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
  }
};
function se(e, t) {
  var n = null, a;
  return p(e) ? a = e : (L(e) ? (n = e[0], a = e[1]) : (n = e.context, a = e.fn), n && x(a) && p(n[a]) && (a = n[a])), {
    context: n,
    fn: a,
    args: t
  };
}
var nt = function(t) {
  return t !== Et;
};
function T(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  if (process.env.NODE_ENV !== "production") {
    var E = typeof n[0] == "number" ? n[0] : "ms";
    R(e, nt, "instead of writing `yield call(delay, " + E + ")` where delay is an effect from `redux-saga/effects` you should write `yield delay(" + E + ")`"), oe("call", e);
  }
  return g(Xe, se(e, n));
}
function V(e) {
  process.env.NODE_ENV !== "production" && (oe("fork", e), R(e, function(E) {
    return !qe(E);
  }, "fork: argument must not be an effect"));
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return g(Ze, se(e, n));
}
function at(e) {
  if (e === void 0 && (e = J), process.env.NODE_ENV !== "production") {
    if (arguments.length > 1)
      throw new Error("cancel(...tasks) is not supported any more. Please use cancel([...tasks]) to cancel multiple tasks.");
    L(e) ? e.forEach(function(t) {
      R(t, W, "cancel([...tasks]): argument " + t + " is not a valid Task object " + X);
    }) : e !== J && C(e) && R(e, W, "cancel(task): argument " + e + " is not a valid Task object " + X);
  }
  return g(et, e);
}
function f(e) {
  e === void 0 && (e = Ye);
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return process.env.NODE_ENV !== "production" && arguments.length && (R(arguments[0], C, "select(selector, [...]): argument selector is undefined"), R(e, p, "select(selector, [...]): argument " + e + " is not a function")), g(tt, {
    selector: e,
    args: n
  });
}
var Et = /* @__PURE__ */ T.bind(null, Ke), Z = function(t) {
  return {
    done: !0,
    value: t
  };
}, Q = {};
function Se(e) {
  return b(e) ? "channel" : $e(e) ? String(e) : p(e) ? e.name : String(e);
}
function re(e, t, n) {
  var a, E, _, c = t;
  function O(N, A) {
    if (c === Q)
      return Z(N);
    if (A && !E)
      throw c = Q, A;
    a && a(N);
    var y = A ? e[E](A) : e[c]();
    return c = y.nextState, _ = y.effect, a = y.stateUpdater, E = y.errorState, c === Q ? Z(N) : _;
  }
  return Je(O, function(N) {
    return O(null, N);
  }, n);
}
function ot(e, t) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), E = 2; E < n; E++)
    a[E - 2] = arguments[E];
  var _ = {
    done: !1,
    value: Ee(e)
  }, c = function(y) {
    return {
      done: !1,
      value: V.apply(void 0, [t].concat(a, [y]))
    };
  }, O, N = function(y) {
    return O = y;
  };
  return re({
    q1: function() {
      return {
        nextState: "q2",
        effect: _,
        stateUpdater: N
      };
    },
    q2: function() {
      return {
        nextState: "q1",
        effect: c(O)
      };
    }
  }, "q1", "takeEvery(" + Se(e) + ", " + t.name + ")");
}
function st(e, t) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), E = 2; E < n; E++)
    a[E - 2] = arguments[E];
  var _ = {
    done: !1,
    value: Ee(e)
  }, c = function(G) {
    return {
      done: !1,
      value: V.apply(void 0, [t].concat(a, [G]))
    };
  }, O = function(G) {
    return {
      done: !1,
      value: at(G)
    };
  }, N, A, y = function(G) {
    return N = G;
  }, F = function(G) {
    return A = G;
  };
  return re({
    q1: function() {
      return {
        nextState: "q2",
        effect: _,
        stateUpdater: F
      };
    },
    q2: function() {
      return N ? {
        nextState: "q3",
        effect: O(N)
      } : {
        nextState: "q1",
        effect: c(A),
        stateUpdater: y
      };
    },
    q3: function() {
      return {
        nextState: "q1",
        effect: c(A),
        stateUpdater: y
      };
    }
  }, "q1", "takeLatest(" + Se(e) + ", " + t.name + ")");
}
var Te = function(t, n, a) {
  R(n, C, t.name + " requires a pattern or channel"), R(a, C, t.name + " requires a saga parameter");
};
function P(e, t) {
  process.env.NODE_ENV !== "production" && Te(P, e, t);
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), E = 2; E < n; E++)
    a[E - 2] = arguments[E];
  return V.apply(void 0, [ot, e, t].concat(a));
}
function u(e, t) {
  process.env.NODE_ENV !== "production" && Te(u, e, t);
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), E = 2; E < n; E++)
    a[E - 2] = arguments[E];
  return V.apply(void 0, [st, e, t].concat(a));
}
function* q() {
  try {
    const e = yield T(
      De
    );
    yield S(Re(e));
  } catch {
    yield S(le());
  }
}
function* St(e) {
  try {
    const t = yield T(
      Me,
      e.payload
    );
    yield S(
      Ne(
        ce(t.content, t.totalElements)
      )
    ), yield T(q);
  } catch (t) {
    console.log(t), yield S(Ae());
  }
}
function* rt(e) {
  try {
    e.payload && (yield T(ve, e.payload), yield S(Ce(e.payload)), yield T(q));
  } catch {
    yield S(ye());
  }
}
function* Cn() {
  yield u(i.GET_NOTIFICATIONS, St), yield u(
    i.MARK_NOTIFICATIONS_READ,
    rt
  ), yield u(
    i.GET_NOTIFICATIONS_UNREAD,
    q
  );
}
var r = /* @__PURE__ */ ((e) => (e.GET_INVITATIONS = "GET_INVITATIONS", e.GET_INVITATIONS_SUCCESS = "GET_INVITATIONS_SUCCESS", e.GET_INVITATIONS_ERROR = "GET_INVITATIONS_ERROR", e.ACCEPT_INVITATION = "ACCEPT_INVITATION", e.ACCEPT_INVITATION_SUCCESS = "ACCEPT_INVITATION_SUCCESS", e.ACCEPT_INVITATION_ERROR = "ACCEPT_INVITATION_ERROR", e.DECLINE_INVITATION = "DECLINE_INVITATION", e.DECLINE_INVITATION_SUCCESS = "DECLINE_INVITATION_SUCCESS", e.DECLINE_INVITATION_ERROR = "DECLINE_INVITATION_ERROR", e.GET_INVITATIONS_COUNT = "GET_INVITATIONS_COUNT", e.GET_INVITATIONS_COUNT_SUCCESS = "GET_INVITATIONS_COUNT_SUCCESS", e.GET_INVITATIONS_COUNT_ERROR = "GET_INVITATIONS_COUNT_ERROR", e))(r || {});
const yn = () => ({
  type: r.GET_INVITATIONS
}), Tt = (e) => ({
  type: r.GET_INVITATIONS_SUCCESS,
  payload: e
}), It = () => ({
  type: r.GET_INVITATIONS_SUCCESS
}), On = () => ({
  type: r.GET_INVITATIONS_COUNT
}), ct = (e) => ({
  type: r.GET_INVITATIONS_COUNT_SUCCESS,
  payload: e
}), it = () => ({
  type: r.GET_INVITATIONS_COUNT_ERROR
}), pn = (e) => ({
  type: r.ACCEPT_INVITATION,
  payload: { path: e }
}), _t = () => ({
  type: r.ACCEPT_INVITATION_SUCCESS
}), ut = () => ({
  type: r.ACCEPT_INVITATION_ERROR
}), Un = (e, t) => ({
  type: r.DECLINE_INVITATION,
  payload: { note: e, path: t }
}), dt = () => ({
  type: r.DECLINE_INVITATION_SUCCESS
}), Rt = () => ({
  type: r.DECLINE_INVITATION_ERROR
});
function* K() {
  try {
    const e = yield T(Ue);
    yield S(Tt(ie(e)));
  } catch {
    yield S(It());
  }
}
function* Y() {
  try {
    const e = yield T(ge);
    yield S(ct(e.total));
  } catch {
    yield S(it());
  }
}
function* lt(e) {
  try {
    const { path: t } = e.payload;
    yield T(fe, t), yield S(_t()), yield T(Y), yield T(K);
  } catch {
    yield S(ut());
  }
}
function* Nt(e) {
  try {
    const { path: t, note: n } = e.payload;
    yield T(Ge, n, t), yield S(dt()), yield T(Y), yield T(K);
  } catch {
    yield S(Rt());
  }
}
function* gn() {
  yield u(r.GET_INVITATIONS, K), yield u(
    r.GET_INVITATIONS_COUNT,
    Y
  ), yield u(r.ACCEPT_INVITATION, lt), yield u(
    r.DECLINE_INVITATION,
    Nt
  );
}
const At = {
  status: o.INITIAL,
  invitations: [],
  count: 0,
  countStatus: o.INITIAL
}, fn = (e = At, t) => D(e, (n) => {
  switch (t.type) {
    case r.GET_INVITATIONS_COUNT:
      n.countStatus = o.IN_PROGRESS;
      break;
    case r.GET_INVITATIONS_COUNT_SUCCESS:
      n.countStatus = o.SUCCESS, n.count = t.payload;
      break;
    case r.GET_INVITATIONS_COUNT_ERROR:
      n.countStatus = o.ERROR;
      break;
    case r.GET_INVITATIONS:
      n.status = n.status === o.INITIAL ? o.IN_PROGRESS : o.IN_PROGRESS_RELOAD;
      break;
    case r.GET_INVITATIONS_SUCCESS:
      n.status = o.SUCCESS, n.invitations = t.payload.data, n.count = t.payload.count;
      break;
    case r.GET_INVITATIONS_ERROR:
      n.status = o.ERROR;
      break;
    case r.ACCEPT_INVITATION:
      break;
    case r.ACCEPT_INVITATION_SUCCESS:
      n.status = o.SUCCESS;
      break;
    case r.ACCEPT_INVITATION_ERROR:
      n.status = o.ERROR;
      break;
    case r.DECLINE_INVITATION:
      break;
    case r.DECLINE_INVITATION_SUCCESS:
      n.status = o.SUCCESS;
      break;
    case r.DECLINE_INVITATION_ERROR:
      n.status = o.ERROR;
      break;
  }
});
var I = /* @__PURE__ */ ((e) => (e.USER_SIGN_IN_REQUEST = "USER_SIGN_IN_REQUEST", e.USER_SIGN_IN_REQUEST_DONE = "USER_SIGN_IN_REQUEST_DONE", e.USER_SIGN_IN_REQUEST_FAILED = "USER_SIGN_IN_REQUEST_FAILED", e.USER_SIGN_OUT_REQUEST = "USER_SIGN_OUT_REQUEST", e.USER_SIGN_OUT_REQUEST_DONE = "USER_SIGN_OUT_REQUEST_DONE", e.USER_SIGN_OUT_REQUEST_FAILED = "USER_SIGN_OUT_REQUEST_FAILED", e.USER_GET_REQUEST = "USER_GET_REQUEST", e.USER_GET_REQUEST_DONE = "USER_GET_REQUEST_DONE", e.USER_GET_REQUEST_FAILED = "USER_GET_REQUEST_FAILED", e.RESET_USER_DATA = "RESET_USER_DATA", e.SWITCH_TENANT = "SWITCH_TENANT", e))(I || {});
const Gn = (e, t) => ({
  type: I.USER_SIGN_IN_REQUEST,
  payload: { userName: e, password: t }
}), Ct = (e) => ({
  type: I.USER_SIGN_IN_REQUEST_DONE,
  payload: e
}), yt = (e) => ({
  type: I.USER_SIGN_IN_REQUEST_FAILED,
  payload: e
}), Dn = () => ({
  type: I.USER_GET_REQUEST
}), Ot = (e) => ({
  type: I.USER_GET_REQUEST_DONE,
  payload: e
}), pt = () => ({
  type: I.USER_GET_REQUEST_FAILED
}), Mn = () => ({
  type: I.USER_SIGN_OUT_REQUEST
}), vn = () => ({
  type: I.RESET_USER_DATA
}), mn = () => ({
  type: I.USER_SIGN_OUT_REQUEST
}), Ut = () => ({
  type: I.USER_SIGN_OUT_REQUEST_DONE
}), Ln = (e) => ({
  type: I.SWITCH_TENANT,
  payload: { tenantId: e }
}), gt = {
  data: null,
  status: o.INITIAL,
  loginStatus: o.INITIAL,
  errorMessage: ""
}, Pn = (e = gt, t) => D(e, (n) => {
  switch (t.type) {
    case I.USER_SIGN_IN_REQUEST_DONE:
      n.data = t.payload, n.loginStatus = o.SUCCESS, n.status = o.SUCCESS;
      break;
    case I.USER_SIGN_IN_REQUEST_FAILED:
      n.data = null, n.loginStatus = o.ERROR, n.errorMessage = t.payload;
      break;
    case I.USER_GET_REQUEST:
      n.status = o.IN_PROGRESS;
      break;
    case I.USER_GET_REQUEST_DONE:
      n.data = {
        ...t.payload.user,
        settings: t.payload.settings
      }, n.status = o.SUCCESS;
      break;
    case I.USER_GET_REQUEST_FAILED:
      n.status = o.ERROR, n.data = null;
      break;
    case I.RESET_USER_DATA:
      n.status = o.INITIAL, n.data = null;
      break;
    case I.USER_SIGN_OUT_REQUEST_DONE:
      n.status = o.ERROR, n.loginStatus = o.INITIAL, n.data = null, n.errorMessage = "";
      break;
  }
}), ft = (e) => d.post(`/users/tenant/${e}/active`, { tenantId: e });
function* Gt(e) {
  const { userName: t, password: n } = e.payload;
  try {
    const a = yield T(me, t, n);
    yield S(Ct(a)), yield T($);
  } catch (a) {
    let E = (a == null ? void 0 : a.response.status) === 401 ? "Wrong user name or password." : `An error has occurred: ${a == null ? void 0 : a.response.status}.`;
    yield S(yt(E));
  }
}
function* Dt() {
  try {
    yield T(be), yield S(Ut());
  } catch (e) {
    console.error(e);
  }
}
function* $() {
  try {
    const e = yield T(Le), t = yield T(Pe);
    yield S(Ot({ user: e, settings: t }));
  } catch {
    yield S(pt());
  }
}
function* Mt(e) {
  try {
    const { tenantId: t } = e.payload;
    yield T(ft, t), location.reload();
  } catch {
  }
}
function* bn() {
  yield T($), yield u(I.USER_SIGN_IN_REQUEST, Gt), yield u(I.USER_SIGN_OUT_REQUEST, Dt), yield u(I.USER_GET_REQUEST, $), yield u(I.SWITCH_TENANT, Mt);
}
var j = /* @__PURE__ */ ((e) => (e.SET_GLOBAL_OBJECT = "SET_GLOBAL_OBJECT", e))(j || {});
const hn = (e, t) => ({
  type: j.SET_GLOBAL_OBJECT,
  payload: { name: e, object: t }
}), vt = {
  objects: {}
}, Vn = (e = vt, t) => _e(e, (n) => {
  switch (t.type) {
    case j.SET_GLOBAL_OBJECT:
      n.objects[t.payload.name] = t.payload.object;
  }
});
var v = /* @__PURE__ */ ((e) => (e.SET_BREADCRUMB = "SET_BREADCRUMB", e.SET_BREADCRUMBS = "SET_BREADCRUMBS", e.RESET_BREADCRUMBS = "RESET_BREADCRUMBS", e))(v || {});
const Fn = (e) => ({
  type: v.SET_BREADCRUMBS,
  payload: e
}), kn = () => ({
  type: v.RESET_BREADCRUMBS
}), mt = {
  // status: Status.INITIAL,
  breadcrumbs: []
}, wn = (e = mt, t) => D(e, (n) => {
  switch (t.type) {
    case v.SET_BREADCRUMBS: {
      n.breadcrumbs = t.payload;
      break;
    }
    case v.RESET_BREADCRUMBS:
      n.breadcrumbs = [];
      break;
  }
});
var U = /* @__PURE__ */ ((e) => (e.GET_SUMMARY = "GET_SUMMARY", e.GET_SUMMARY_SUCCESS = "GET_SUMMARY_SUCCESS", e.GET_SUMMARY_ERROR = "GET_SUMMARY_ERROR", e.RESET_SUMMARY = "RESET_SUMMARY", e))(U || {});
const Qn = (e, t) => ({
  type: U.GET_SUMMARY,
  payload: { typeOfContainer: e, id: t }
}), Lt = (e) => ({
  type: U.GET_SUMMARY_SUCCESS,
  payload: e
}), Pt = () => ({
  type: U.GET_SUMMARY_ERROR
}), $n = () => ({
  type: U.RESET_SUMMARY
}), bt = {
  data: null,
  status: o.INITIAL
}, Bn = (e = bt, t) => D(e, (n) => {
  switch (t.type) {
    case U.GET_SUMMARY:
      n.status = n.status === o.INITIAL ? o.IN_PROGRESS : o.IN_PROGRESS_RELOAD;
      break;
    case U.GET_SUMMARY_SUCCESS:
      n.status = o.SUCCESS, n.data = t.payload;
      break;
    case U.GET_SUMMARY_ERROR:
      n.status = o.ERROR;
      break;
    case U.RESET_SUMMARY:
      n.status = o.INITIAL, n.data = null;
      break;
  }
});
function* ht(e) {
  try {
    const { typeOfContainer: t, id: n } = e.payload, a = yield T(he, t, n);
    yield S(Lt(a));
  } catch {
    yield S(Pt());
  }
}
function* xn() {
  yield u(U.GET_SUMMARY, ht);
}
var l = /* @__PURE__ */ ((e) => (e.GET_IMAGES = "GET_IMAGES", e.GET_IMAGES_SUCCESS = "GET_IMAGES_SUCCESS", e.GET_IMAGES_ERROR = "GET_IMAGES_ERROR", e.GET_IMAGE = "GET_IMAGE", e.GET_IMAGE_SUCCESS = "GET_IMAGE_SUCCESS", e.GET_IMAGE_ERROR = "GET_IMAGE_ERROR", e))(l || {});
const Vt = {
  status: o.INITIAL,
  images: {}
}, qn = (e = Vt, t) => D(e, (n) => {
  switch (t.type) {
    case l.GET_IMAGES:
      n.status = n.status === o.INITIAL ? o.IN_PROGRESS : o.IN_PROGRESS_RELOAD;
      break;
    case l.GET_IMAGES_SUCCESS:
      n.status = o.SUCCESS, n.images = t.payload.data;
      break;
    case l.GET_IMAGES_ERROR:
      n.status = o.ERROR;
      break;
    case l.GET_IMAGE:
      n.status = n.status === o.INITIAL ? o.IN_PROGRESS : o.IN_PROGRESS_RELOAD;
      break;
    case l.GET_IMAGE_SUCCESS:
      t.payload && (n.images[t.payload.id] = t.payload), n.status = o.SUCCESS;
      break;
    case l.GET_IMAGE_ERROR:
      n.status = o.ERROR;
      break;
  }
});
function Kn(e) {
  return {
    type: l.GET_IMAGES,
    payload: e
  };
}
function Ft(e) {
  return {
    type: l.GET_IMAGES_SUCCESS,
    payload: e
  };
}
function kt(e) {
  return {
    type: l.GET_IMAGES_ERROR,
    payload: e
  };
}
function Yn(e, t = !1) {
  return {
    type: l.GET_IMAGE,
    payload: { id: e, reload: t }
  };
}
function ee(e) {
  return {
    type: l.GET_IMAGE_SUCCESS,
    payload: e
  };
}
function jn(e) {
  return {
    type: l.GET_IMAGE_ERROR,
    payload: e
  };
}
const wt = (e) => d.get(
  `/datasource/logo/list${e != null && e.length ? `?id=${e.join("&id=")}` : ""}`
), Qt = (e) => d.get(`/datasource/${e}/logo`), $t = (e) => e.images;
function* Bt(e) {
  try {
    const t = yield T(
      wt,
      e.payload
    );
    yield S(Ft(t.content));
  } catch {
    yield S(kt());
  }
}
function* xt(e) {
  const { id: t, reload: n = !1 } = e.payload;
  try {
    if (!(yield f($t)[t]) || n) {
      const E = yield T(Qt, t);
      yield S(ee(E || { id: t }));
    }
  } catch {
    yield S(ee({ id: t }));
  }
}
function* Hn() {
  yield u(l.GET_IMAGES, Bt), yield P(l.GET_IMAGE, xt);
}
var s = /* @__PURE__ */ ((e) => (e.ADD_COMPARE_ITEM = "ADD_COMPARE_ITEM", e.ADD_COMPARE_ITEM_START = "ADD_COMPARE_ITEM_START", e.ADD_COMPARE_ITEM_SUCCESS = "ADD_COMPARE_ITEM_SUCCESS", e.REMOVE_COMPARE_ITEM = "REMOVE_COMPARE_ITEM", e.REMOVE_COMPARE_ITEM_START = "REMOVE_COMPARE_ITEM_START", e.REMOVE_COMPARE_ITEM_SUCCESS = "REMOVE_COMPARE_ITEM_SUCCESS", e.RESET_COMPARE = "RESET_COMPARE", e.GET_COMPARE_COUNT = "GET_COMPARE_COUNT", e.SET_COMPARE_DATA = "SET_COMPARE_DATA", e.SET_COUNT = "SET_COUNT", e.SET_PRELOADED_STATE = "SET_PRELOADED_STATE", e.SET_PRELOADED_STATE_SUCCESS = "SET_PRELOADED_STATE_SUCCESS", e.GET_INCLUDED = "GET_INCLUDED", e.SET_INCLUDED = "SET_INCLUDED", e.GET_INCLUDED_SUCCESS = "GET_INCLUDED_SUCCESS", e.SET_METADATA = "SET_METADATA", e.RELOAD_COMPARE_DATA = "RELOAD_COMPARE_DATA", e))(s || {});
const Jn = (e, t) => ({
  type: s.ADD_COMPARE_ITEM,
  payload: { entityType: e, item: t }
}), qt = (e, t) => ({
  type: s.ADD_COMPARE_ITEM_START,
  payload: { entityType: e, item: t }
}), Kt = () => ({
  type: s.ADD_COMPARE_ITEM_SUCCESS
}), Wn = (e, t) => ({
  type: s.REMOVE_COMPARE_ITEM,
  payload: { entityType: e, id: t.id, versionId: t.versionId }
}), Yt = (e, t) => ({
  type: s.REMOVE_COMPARE_ITEM_START,
  payload: { entityType: e, id: t.id, versionId: t.versionId }
}), jt = () => ({
  type: s.REMOVE_COMPARE_ITEM_SUCCESS
}), Ht = (e, t) => ({
  type: s.SET_COUNT,
  payload: { entityType: e, counts: t }
}), Ie = (e, t) => ({
  type: s.SET_COMPARE_DATA,
  payload: { entityType: e, data: t }
}), Jt = (e) => ({
  type: s.SET_PRELOADED_STATE,
  payload: e
}), Wt = () => ({
  type: s.SET_PRELOADED_STATE_SUCCESS
}), zn = (e) => ({
  type: s.GET_INCLUDED,
  payload: e
}), Xn = (e, t) => ({
  type: s.SET_INCLUDED,
  payload: { entityType: e, data: t }
}), zt = (e, t) => ({
  type: s.SET_METADATA,
  payload: { entityType: e, data: t }
}), Zn = () => ({
  type: s.RELOAD_COMPARE_DATA
}), te = {
  ids: {
    conceptSets: [],
    cohorts: [],
    analyses: []
  },
  data: {
    conceptSets: [],
    cohorts: [],
    analyses: [],
    includedConcepts: [],
    includedSourceCodes: []
  },
  metadata: {
    conceptSets: []
  },
  counts: {
    conceptSets: [],
    includedConceptsCounts: [],
    includedSourceCodesCounts: [],
    includedConcepts: [],
    includedSourceCodes: [],
    cohorts: [],
    analyses: [],
    total: []
  },
  status: {
    conceptSets: o.INITIAL,
    includedConceptsCounts: o.INITIAL,
    includedConcepts: o.INITIAL,
    includedSourceCodes: o.INITIAL,
    includedSourceCodesCounts: o.INITIAL,
    cohorts: o.INITIAL,
    analyses: o.INITIAL
  }
}, B = (e) => (t) => (t == null ? void 0 : t.id) === e.id && e.versionId === (t == null ? void 0 : t.versionId), ea = (e = te, t) => D(e, (n) => {
  switch (t.type) {
    case s.ADD_COMPARE_ITEM_START: {
      const { entityType: a, item: E } = t.payload;
      n.data[a] || (n.data[a] = []);
      const _ = n.data[a].findIndex(B(E)), c = n.ids[a].findIndex(B(E));
      _ == -1 && c == -1 ? (n.data[a].push(E), n.ids[a].push({
        id: E.id,
        versionId: E.versionId,
        typeContainer: E.typeContainer,
        parentId: E.parentId
      })) : n.data[a][_] = E;
      break;
    }
    case s.SET_COMPARE_DATA: {
      const { entityType: a, data: E } = t.payload;
      n.data[a] = E, n.status[a] = o.SUCCESS;
      break;
    }
    case s.REMOVE_COMPARE_ITEM: {
      const { entityType: a, id: E, versionId: _ } = t.payload, c = n.ids[a].findIndex(
        (O) => O.id === E && O.versionId === _
      );
      n.data[a].splice(c, 1), n.ids[a].splice(c, 1), n.counts[a].splice(c, 1), n.metadata[a].splice(c, 1);
      break;
    }
    case s.SET_COUNT: {
      const { entityType: a, counts: E } = t.payload;
      n.counts[a] = E, n.status[a] = o.SUCCESS;
      break;
    }
    case s.SET_PRELOADED_STATE: {
      const a = t.payload;
      n.ids = a.ids || n.ids;
      break;
    }
    case s.GET_INCLUDED: {
      const E = t.payload === "included" ? "includedConcepts" : "includedSourceCodes";
      n.status[E] = o.IN_PROGRESS;
      break;
    }
    case s.RESET_COMPARE: {
      n.data = te.data;
      break;
    }
    case s.SET_METADATA: {
      const { entityType: a, data: E } = t.payload;
      n.metadata[a] = E;
      break;
    }
    default:
      return n;
  }
});
function Xt(e) {
  try {
    const t = localStorage.getItem(e + "_persistedState");
    return t ? JSON.parse(t) : void 0;
  } catch {
    return;
  }
}
function Zt(e, t) {
  try {
    const n = { compare: { ids: t.ids, data: {}, counts: {} } };
    localStorage.setItem(
      e + "_persistedState",
      JSON.stringify(n)
    ), console.log(
      "[localStorage] ✅ Saved compare state to localStorage:",
      n
    );
  } catch (n) {
    console.error("[localStorage] ❌ Failed to save compare state:", n);
  }
}
const en = (e, t, n, a, E) => {
  const { pageNumber: _, pageSize: c, sortBy: O, query: N } = t, A = ue(O), y = `/conceptset/${n}/${e}/list?size=${c || "1000000"}&page=${_ || ""}&sort=${A}` + (N ? `&${N}` : "") + `&versionId=${a || ""}`;
  return d.post(y, E || { delta: [] }).then((F) => ({ ...F, id: n, versionId: a })).catch(() => null);
}, tn = (e, t, n) => d.post(`/conceptset/${t}/${e}/total?versionId=${n}`, {
  delta: []
}).catch(() => null), nn = (e) => d.get("/conceptset/version/" + e).catch(() => null), an = (e, t) => {
  let n = "";
  e && t && (n += `?size=1000000&page=0&${e}=${t}`);
  const a = `/conceptset/metadata-value/list${n}`;
  return d.get(a);
}, H = (e) => e.compare.ids.conceptSets;
function* En() {
  const e = yield f((n) => n.user.data), t = yield f((n) => n.compare);
  Zt(e.id + e.activeTenant, t);
}
function* on() {
  try {
    const e = yield f((n) => n.user.data), t = Xt(e.id + e.activeTenant);
    t && (yield S(Jt(t.compare)), yield S(Wt()));
  } catch (e) {
    console.error(e);
  }
}
function* sn(e) {
  try {
    const { entityType: t, item: n } = e.payload;
    if (!n.versionId)
      throw new Error(
        "Something went wrong, compare item missing required data (versionId)"
      );
    yield S(qt(t, n)), yield S(Kt());
  } catch (t) {
    console.error(t);
  }
}
function* Sn(e) {
  try {
    const { entityType: t, id: n, versionId: a } = e.payload;
    yield S(Yt(t, { id: n, versionId: a })), yield S(jt());
  } catch (t) {
    console.error(t);
  }
}
function* rn() {
  try {
    const e = yield f(H), t = yield h(
      e.map((n) => T(nn, n.versionId))
    );
    yield S(
      Ie(
        "conceptSets",
        t.map(
          (n, a) => n ? {
            ...n.data,
            id: e[a].id,
            ordinal: n.ordinal,
            latest: n.latest
          } : {
            id: e[a].id,
            versionId: e[a].versionId,
            name: "N/A (Version not found)"
          }
        )
      )
    );
  } catch (e) {
    console.error(e);
  }
}
function* Tn() {
  try {
    const e = yield f(H), t = yield h(
      e.map(
        (n) => T(an, "filter.metadata.value.subject.id", n.id)
      )
    );
    yield S(zt("conceptSets", t));
  } catch (e) {
    console.error(e);
  }
}
function* In(e) {
  const t = e.payload === "included" ? "includedConcepts" : "includedSourceCodes";
  try {
    const n = yield f((_) => _.compare.ids.conceptSets), a = yield f((_) => _.compare.data[t]), E = yield h(
      n.map((_) => {
        const c = a == null ? void 0 : a.find(B(_));
        return c || T(
          en,
          e.payload,
          {},
          _.id,
          _.versionId
        );
      })
    );
    yield S(Ie(t, E));
  } catch (n) {
    console.error(n);
  }
}
function* ne(e = "included") {
  const t = e === "included" ? "includedConceptsCounts" : "includedSourceCodesCounts";
  try {
    const n = yield f(H), a = yield h(
      n.map(
        (E) => T(tn, e, E.id, E.versionId)
      )
    );
    yield S(Ht(t, a));
  } catch (n) {
    console.error(n);
  }
}
function* ta() {
  yield u(
    [I.USER_GET_REQUEST_DONE, I.USER_SIGN_IN_REQUEST_DONE],
    on
  ), yield u(
    [
      s.SET_PRELOADED_STATE_SUCCESS,
      s.ADD_COMPARE_ITEM_SUCCESS,
      s.RELOAD_COMPARE_DATA
    ],
    rn
  ), yield u(
    [
      s.SET_PRELOADED_STATE_SUCCESS,
      s.ADD_COMPARE_ITEM_SUCCESS
    ],
    Tn
  ), yield u(
    [
      s.SET_PRELOADED_STATE_SUCCESS,
      s.ADD_COMPARE_ITEM_SUCCESS
    ],
    ne,
    "included"
  ), yield u(
    [
      s.SET_PRELOADED_STATE_SUCCESS,
      s.ADD_COMPARE_ITEM_SUCCESS
    ],
    ne,
    "included-source-code"
  ), yield u(
    [
      s.ADD_COMPARE_ITEM_SUCCESS,
      s.REMOVE_COMPARE_ITEM_SUCCESS
    ],
    En
  ), yield P(s.ADD_COMPARE_ITEM, sn), yield P(s.REMOVE_COMPARE_ITEM, Sn), yield u(
    [s.GET_INCLUDED, s.REMOVE_COMPARE_ITEM_SUCCESS],
    In
  );
}
export {
  v as BreadcrumbsActions,
  s as CompareActions,
  j as GlobalObjects,
  Vt as INITIAL_STATE_IMAGES,
  l as ImagesActions,
  r as InvitationsActions,
  i as NotificationsActions,
  U as SummaryActions,
  I as UserActions,
  pn as acceptInvitation,
  ut as acceptInvitationFailed,
  _t as acceptInvitationSuccess,
  Jn as addCompareItem,
  qt as addCompareItemStart,
  Kt as addCompareItemSuccess,
  wn as breadcrumbsReducer,
  ea as compareReducer,
  ta as compareSaga,
  Un as declineInvitation,
  Rt as declineInvitationFailed,
  dt as declineInvitationSuccess,
  Yn as getImage,
  ee as getImageDone,
  jn as getImageFail,
  Kn as getImages,
  Ft as getImagesDone,
  kt as getImagesFail,
  zn as getIncluded,
  yn as getInvitations,
  On as getInvitationsCount,
  ct as getInvitationsCountDone,
  it as getInvitationsCountFailed,
  Tt as getInvitationsDone,
  It as getInvitationsFailed,
  ln as getNotifications,
  Rn as getNotificationsUnread,
  Qn as getSummary,
  Pt as getSummaryFailed,
  Lt as getSummarySuccess,
  B as getUniqueItem,
  Dn as getUser,
  Ot as getUserDone,
  pt as getUserFailed,
  Vn as globalObjectReducer,
  qn as imagesReducer,
  Hn as imagesSaga,
  fn as invitationsReducer,
  gn as invitationsSaga,
  Ne as notificationsGetDone,
  Ae as notificationsGetFailed,
  An as notificationsReducer,
  Cn as notificationsSaga,
  Re as notificationsUnreadGetDone,
  le as notificationsUnreadGetFailed,
  Zn as reloadCompareData,
  Wn as removeCompareItem,
  Yt as removeCompareItemStart,
  jt as removeCompareItemSuccess,
  kn as resetBreadcrumbs,
  $n as resetSummary,
  vn as resetUserData,
  Fn as setBreadcrumbs,
  Ie as setCompareData,
  Ht as setCount,
  hn as setGlobalObject,
  Xn as setIncluded,
  zt as setMetdata,
  Jt as setPreloadedState,
  Wt as setPreloadedStateSuccess,
  mn as signOutUser,
  Ut as signOutUserDone,
  Bn as summaryReducer,
  xn as summarySaga,
  Ln as switchTenant,
  Nn as updateNotifications,
  Ce as updateNotificationsDone,
  ye as updateNotificationsFailed,
  Pn as userReducer,
  bn as userSaga,
  Gn as userSignIn,
  Ct as userSignInDone,
  yt as userSignInFailed,
  Mn as userSignOut
};
//# sourceMappingURL=redux.js.map
